import Reflux from 'reflux';

export default Reflux.createActions(['removeLocks', 'loadLocks']);



// WEBPACK FOOTER //
// ./modules/actions/chapter_actions.js